<script setup lang="ts">
import { TicketIcon } from 'assets/data/icons';
</script>
<template>
  <svg
    class="w-4 h-4 mt-1"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path :d="TicketIcon" fill="url(#paint0_linear_49048_1633)" />
    <defs>
      <linearGradient
        id="paint0_linear_49048_1633"
        x1="8"
        y1="2.66699"
        x2="8"
        y2="13.3337"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F8F8F9" />
        <stop offset="1" stop-color="#C5C6CE" />
      </linearGradient>
    </defs>
  </svg>
</template>
